export default {"src":"/_next/static/media/smartphone.e5097b11.svg","height":53,"width":62,"blurWidth":0,"blurHeight":0};